import TasksService from 'aurora-composition/services/tasksService';
import WorkflowService from 'aurora-composition/services/workflowService';
import history from 'aurora-utils/history';

import {
  CleverTapCancelApplicationDetails,
  CleverTapCancelApplicationDetailsSuccess,
  CleverTapCancelApplicationDetailsFailure,
} from 'aurora-utils/cleverTap.eventhelper';
import * as types from './constants';

export const fetchApplicationSuccess = tasks => ({
  type: types.FETCH_APPLICATION_SUCCESS,
  payload: {
    tasks,
  },
});

export const fetchApplicationError = error => ({
  type: types.FETCH_APPLICATION_ERROR,
  payload: {
    error,
  },
});

export const fetchApplication = data => async dispatch => {
  try {
    const { filters = {}, page = 0, size = 5 } = data;
    dispatch({ type: types.FETCH_APPLICATION });
    const response = await TasksService.fetchTasks(page, size, filters);
    const res = response?.data?.result || response?.result;
    dispatch(
      fetchApplicationSuccess({
        data: res?.applications || [],
        page: {},
        pageNumber: page,
        totalPages: res.totalPages,
        totalRecord: res.recordsTotal,
      }),
    );
  } catch (e) {
    dispatch(fetchApplicationError(e));
  }
};

export const discardApplication = (id, application, param = null) => async dispatch => {
  const cleverTapPayload = {
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationDetails?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationDetails?.applicationType,
    contractNumber: application?.mortgage?.details?.contractNumber,
    contractStartDate: application?.mortgage?.details?.startDate,
    contractEndDate: application?.mortgage?.details?.endDate,
  };
  try {
    dispatch({ type: types.DISCARD_APPLICATION_LOADING });
    CleverTapCancelApplicationDetails(cleverTapPayload);
    await WorkflowService.cancelApplication(id, param);
    dispatch({ type: types.DISCARD_APPLICATION_SUCCESS });
    CleverTapCancelApplicationDetailsSuccess(cleverTapPayload);
    history.replace('/app/services');
  } catch (error) {
    cleverTapPayload.errorCode = error?.statusCode;
    cleverTapPayload.errorMessage = error?.data?.result?.description;
    dispatch({ type: types.DISCARD_APPLICATION_ERROR, payload: error });
    CleverTapCancelApplicationDetailsFailure(cleverTapPayload);
  }
};
